const filterAdministrationDashboardResults = function ({ commit }, data) {
  commit("SET_ADMINISTRATION_SEARCH_PHRASE", data);

  return Promise.resolve();
};

export default filterAdministrationDashboardResults;
